<h2 class="thm-page-title ng-star-inserted"> Ödeme Sonuç </h2>

<thm-alert type="light" class="mt-2">

  <h6 *ngIf="odemeBasarili" class="alert-heading text-success"><i class="fa fa-check" aria-hidden="true"></i> Ödeme İşlemi BAŞARILI! </h6>

  <hr style="margin: 10px 0 10px 0">

  <div class="block mb-0 mt-2" style="font-weight: 600;">
    <div class="headline">
      Başvurularınızı görüntülemek için
      <thm-button buttonType="primary" buttonSize="sm" class="mr-1" [routerLink]="['/aday/kesin-kayit-basvuru/listele']">
        TIKLAYINIZ
      </thm-button>
    </div>
  </div>

</thm-alert>